const PageNames = {
  HOME: 'hotels_home',
  SEARCH: 'hotels_results',
  DETAILS: 'hotels_details',
  SEO_DETAILS: 'seo_hotel_details',
  DEALS: 'hotels_deals',
} as const;

export default PageNames;
